(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["klaviyo-form-handlers"] && !Shopify.designMode) return;
  try {
    window.addEventListener('klaviyoForms', function (e) {
    if (
      e.detail.type === 'redirectedToUrlFromStep' &&
      (e.detail.formId === 'VGeqtx' || e.detail.formId === 'Xi24u5')
    ) {
      window.location.href = `${window.location.pathname}?cpn=xhofq`;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
